import { c as _c } from "react/compiler-runtime";
import Link from "next/link";
import { cn } from "@/lib/utils";
export function BrowseNavigation(t0) {
  const $ = _c(13);
  const {
    recommendationsAvailable,
    personalized,
    browseAll,
    filtered
  } = t0;
  const linkClass = _temp;
  let t1;
  if ($[0] !== browseAll || $[1] !== filtered || $[2] !== personalized || $[3] !== recommendationsAvailable) {
    t1 = recommendationsAvailable && <Link href="/browse" aria-current={!browseAll && !filtered ? "page" : undefined} className={linkClass(!browseAll && !filtered)}>{personalized ? "For you" : "Recommended"}</Link>;
    $[0] = browseAll;
    $[1] = filtered;
    $[2] = personalized;
    $[3] = recommendationsAvailable;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const t2 = browseAll && !filtered ? "page" : undefined;
  const t3 = browseAll && !filtered;
  let t4;
  if ($[5] !== t3) {
    t4 = linkClass(t3);
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t2 || $[8] !== t4) {
    t5 = <Link href="/browse?view=all" aria-current={t2} className={t4}>Browse all</Link>;
    $[7] = t2;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t1 || $[11] !== t5) {
    t6 = <nav aria-label="Browse views" className="flex flex-wrap gap-2">{t1}{t5}</nav>;
    $[10] = t1;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  return t6;
}
function _temp(active) {
  return cn("rounded-lg px-4 py-2 text-sm font-medium transition-colors focus-visible:outline-2 focus-visible:outline-primary", active ? "bg-primary text-primary-foreground" : "text-muted-foreground hover:bg-primary/10 hover:text-foreground");
}